import { createClient } from '@supabase/supabase-js';

/*
 * ─── SUPABASE SCHEMA ────────────────────────────────────────────────────────
 * Run this SQL in the Supabase dashboard → SQL Editor to create the tables
 * and enable Row Level Security.
 *
 * ── TABLE: conversations ────────────────────────────────────────────────────
 *
 * create table conversations (
 *   id          uuid primary key default gen_random_uuid(),
 *   user_id     uuid not null references auth.users(id) on delete cascade,
 *   coach       text not null check (coach in ('daniel', 'sophie')),
 *   messages    jsonb not null default '[]'::jsonb,
 *   created_at  timestamptz not null default now(),
 *   updated_at  timestamptz not null default now()
 * );
 *
 * alter table conversations enable row level security;
 *
 * create policy "Users can read own conversations"
 *   on conversations for select
 *   using (user_id = auth.uid());
 *
 * create policy "Users can insert own conversations"
 *   on conversations for insert
 *   with check (user_id = auth.uid());
 *
 * create policy "Users can update own conversations"
 *   on conversations for update
 *   using (user_id = auth.uid());
 *
 * create policy "Users can delete own conversations"
 *   on conversations for delete
 *   using (user_id = auth.uid());
 *
 * ── TABLE: journal_entries ───────────────────────────────────────────────────
 *
 * create table journal_entries (
 *   id          uuid primary key default gen_random_uuid(),
 *   user_id     uuid not null references auth.users(id) on delete cascade,
 *   body        text not null default '',
 *   created_at  timestamptz not null default now()
 * );
 *
 * alter table journal_entries enable row level security;
 *
 * create policy "Users can read own journal entries"
 *   on journal_entries for select
 *   using (user_id = auth.uid());
 *
 * create policy "Users can insert own journal entries"
 *   on journal_entries for insert
 *   with check (user_id = auth.uid());
 *
 * create policy "Users can update own journal entries"
 *   on journal_entries for update
 *   using (user_id = auth.uid());
 *
 * create policy "Users can delete own journal entries"
 *   on journal_entries for delete
 *   using (user_id = auth.uid());
 *
 * ── OPTIONAL: auto-update updated_at on conversations ───────────────────────
 *
 * create or replace function update_updated_at()
 * returns trigger language plpgsql as $$
 * begin
 *   new.updated_at = now();
 *   return new;
 * end;
 * $$;
 *
 * create trigger conversations_updated_at
 *   before update on conversations
 *   for each row execute procedure update_updated_at();
 *
 * ────────────────────────────────────────────────────────────────────────────
 */

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
